import { useAuth } from 'admin/auth/context/AuthProvider';
import { getToken, setUserPref } from 'admin/auth/utils';
import React, { useEffect, useState } from 'react';
import { Row } from 'react-table';
import TableLoader from '@components/Loaders/TableLoader';
import ItemPage from 'apps/things/app/item/components/ItemPage';
interface IProps {
    row: Row
}

const DistributorItemsTable: React.FC<IProps> = ({ row }) => {
    const { userPref } = useAuth()
    const [distributorReady, setDistributorReady] = useState(false)

    // Prefer the raw row data over the rendered column value so the ID is
    // always available regardless of whether the auto-generated column has
    // been rendered yet.
    const rowDistributorId: string | undefined =
        (row.original as any)?.node?.distributor?._id ||
        row.values['node.distributor._id']

    useEffect(() => {
        if (rowDistributorId) {
            const newPref = { ...userPref, distributorId: rowDistributorId }
            setUserPref(newPref)
            setDistributorReady(true)
        } else {
            // Fall back to whatever is already persisted (e.g. from a previous
            // selection in this session).
            const stored = getToken().userPref
            if (stored?.distributorId) {
                setDistributorReady(true)
            }
        } // eslint-disable-next-line
    }, [rowDistributorId])

    if (!distributorReady) {
        return <TableLoader colSpan={3}/>
    }
    return (<div>
        <ItemPage />
    </div>)
}

export default DistributorItemsTable